import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';

export enum SortValues {
  LATEST_UNLOCKED = 'LATEST_UNLOCKED',
  NEWEST = 'NEWEST',
  PRICE_LOW_HIGH = 'PRICE_LOW_HIGH',
  PRICE_HIGH_LOW = 'PRICE_HIGH_LOW',
}

const messages = defineMessages<SortValues>({
  [SortValues.LATEST_UNLOCKED]: {
    defaultMessage: 'Latest unlocked',
  },
  [SortValues.NEWEST]: {
    defaultMessage: 'Newest',
  },
  [SortValues.PRICE_LOW_HIGH]: {
    defaultMessage: 'Price: Low-High',
  },
  [SortValues.PRICE_HIGH_LOW]: {
    defaultMessage: 'Price: High-Low',
  },
});

type Props = { value: SortValues; onChange: (v: SortValues) => void };

export const SortBy = ({ value, onChange }: Props) => {
  const { formatMessage } = useIntl();

  const options = [
    SortValues.NEWEST,
    SortValues.LATEST_UNLOCKED,
    SortValues.PRICE_LOW_HIGH,
    SortValues.PRICE_HIGH_LOW,
  ].map(sortValue => ({
    label: formatMessage(messages[sortValue]),
    value: sortValue,
  }));

  return (
    <FilterInDropdown buttonLabel={<FormattedMessage {...messages[value]} />}>
      {({ closeDropdown }) => (
        <RadioGroup
          options={options}
          value={value}
          initiallySelectedValue={SortValues.NEWEST}
          name="club-shop-sort-type"
          onChange={newValue => {
            closeDropdown();
            return onChange(newValue);
          }}
        />
      )}
    </FilterInDropdown>
  );
};
